<!-- TODO: Alipay 銀聯の画像は差し替えられる予定、差し替え後ファイル名を変更する -->
<ul
  *ngIf="(isDisplayPaymentMethodSelection && !isKeepMyFare) || (!isSp && isChangePaymentMethod)"
  class="l-tab-menu01__list"
>
  <!-- ▼▼▼ タブ機能のSP版 ここから ▼▼▼ -->
  <li
    *ngIf="isSp && !this.isHandleStoreChanges"
    class="l-tab-menu01__list-item l-tab-menu01__list-item--change is-open u-display-block-sp"
  >
    <div class="l-tab-menu01__change">
      <div class="l-tab-menu01__change-title">
        <!-- Alipay (SP版)-->
        <div
          *ngIf="this.selectedPaymentMethod === 'AP'"
          class="l-tab-menu01__list-item l-tab-menu01__list-item--change c-float-list01__title-item--mt0 is-open"
        >
          <span class="l-tab-menu01__change-title-icon">
            <img src="assets/images/logo_alipay.png" width="88" height="33" alt="{{ 'alt.alipay' | staticMsg }}" />
          </span>
        </div>
        <!-- 銀聯 (SP版)-->
        <div
          *ngIf="this.selectedPaymentMethod === 'CU'"
          class="l-tab-menu01__list-item l-tab-menu01__list-item--change c-float-list01__title-item--mt0 is-open"
        >
          <span class="l-tab-menu01__change-title-icon">
            <img src="assets/images/logo_chinaUnionPay.png" width="88" height="33" alt="{{ 'alt.cup' | staticMsg }}" />
          </span>
        </div>
        <!-- クレジットカード (SP版)-->
        <div
          *ngIf="this.selectedPaymentMethod === 'CD'"
          class="l-tab-menu01__list-item l-tab-menu01__list-item--change c-float-list01__title-item--mt0 is-open"
        >
          <span class="l-tab-menu01__change-title-icon">
            <img
              src="assets/images/icon_credit_card_24.svg"
              width="24"
              height="24"
              alt="{{ 'alt.creditCard' | staticMsg }}"
            />
          </span>
          <span
            class="l-tab-menu01__menu-title-label l-tab-menu01__menu-title-label--em"
            [innerHTML]="
              this.posCountryCode === 'JP'
                ? ('label.creditCard' | staticMsg)
                : ('heading.creditCardOrDebitCardForTitle' | staticMsg)
            "
          ></span>
        </div>
        <!-- ANA SKYコイン (SP版)-->
        <div
          *ngIf="this.selectedPaymentMethod === 'SC'"
          class="l-tab-menu01__list-item l-tab-menu01__list-item--change c-float-list01__title-item--mt0 is-open"
        >
          <span class="l-tab-menu01__change-title-icon">
            <img
              src="assets/images/icon_ana_sky_coins_24.svg"
              width="24"
              height="24"
              alt="{{ 'alt.anaSKYCoins' | staticMsg }}"
            />
          </span>
          <span
            class="l-tab-menu01__menu-title-label l-tab-menu01__menu-title-label--em"
            [innerHTML]="'alt.anaSKYCoins' | staticMsg"
          ></span>
        </div>
        <!-- Paypal (SP版)-->
        <div
          *ngIf="this.selectedPaymentMethod === 'PP'"
          class="l-tab-menu01__list-item l-tab-menu01__list-item--change c-float-list01__title-item--mt0 is-open"
        >
          <span class="l-tab-menu01__change-title-icon">
            <img src="assets/images/logo_paypal.svg" width="88" height="33" alt="{{ 'alt.paypal' | staticMsg }}" />
          </span>
        </div>
        <!-- コンビニエンスストア (SP版)-->
        <div
          *ngIf="this.selectedPaymentMethod === 'CV'"
          class="l-tab-menu01__list-item l-tab-menu01__list-item--change c-float-list01__title-item--mt0 is-open"
        >
          <span class="l-tab-menu01__change-title-icon">
            <img
              src="assets/images/icon_convenience_store_24.svg"
              width="24"
              height="24"
              alt="{{ 'alt.convenienceStore' | staticMsg }}"
            />
          </span>
          <span
            class="l-tab-menu01__menu-title-label l-tab-menu01__menu-title-label--em"
            [innerHTML]="'alt.convenienceStore' | staticMsg"
          ></span>
        </div>
        <!-- 銀行振込 (SP版)-->
        <div
          *ngIf="this.selectedPaymentMethod === 'IB'"
          class="l-tab-menu01__list-item l-tab-menu01__list-item--change c-float-list01__title-item--mt0 is-open"
        >
          <span class="l-tab-menu01__change-title-icon">
            <img
              src="assets/images/icon_internet_transfer_24.svg"
              width="24"
              height="24"
              alt="{{ 'heading.internetBanking' | staticMsg }}"
            />
          </span>
          <span
            class="l-tab-menu01__menu-title-label l-tab-menu01__menu-title-label--em"
            [innerHTML]="'heading.internetBanking' | staticMsg"
          ></span>
        </div>
        <!-- Pay Easy(SP版)-->
        <div
          *ngIf="this.selectedPaymentMethod === 'PE'"
          class="l-tab-menu01__list-item l-tab-menu01__list-item--change c-float-list01__title-item--mt0 is-open"
        >
          <span class="l-tab-menu01__change-title-icon">
            <img src="assets/images/logo_payeasy.svg" width="54" height="40" alt="{{ 'label.payeasy' | staticMsg }}" />
          </span>
        </div>
        <!-- 予約のみ (SP版)-->
        <div
          *ngIf="this.selectedPaymentMethod === 'RE' && isReservationOnly"
          class="l-tab-menu01__list-item l-tab-menu01__list-item--change c-float-list01__title-item--mt0 is-open"
        >
          <!-- ”予約を行う”旨の文言ラベル確認要 -->
          <span
            class="l-tab-menu01__menu-title-label l-tab-menu01__menu-title-label--em"
            [innerHTML]="'label.reserveOnly' | staticMsg"
          ></span>
        </div>
      </div>
      <div class="l-tab-menu01__change-btn">
        <button
          *ngIf="!isReservationOnly"
          id="payment-input-payment-methods-button-1"
          class="c-btn-tertiary c-btn-tertiary--xs"
          aswThrottleClick
          (throttleClick$)="handleStoreChanges()"
        >
          <span class="c-btn-tertiary__text" [innerHTML]="'label.cardChange' | staticMsg"></span>
        </button>
        <button
          *ngIf="isReservationOnly"
          id="payment-input-payment-methods-button-reserved"
          class="c-btn-tertiary c-btn-tertiary--xs"
          (click)="handleStoreChanges()"
        >
          <!-- 「今、支払う」旨のラベル確認要 -->
          <span class="c-btn-tertiary__text" [innerHTML]="'label.payNow' | staticMsg"></span>
        </button>
      </div>
    </div>
  </li>
  <!-- ▲▲▲ タブ機能のSP版 ここまで ▲▲▲ -->
  <!-- ▼▼▼ タブ機能のPC版 ここから ▼▼▼ -->
  <li *ngIf="!isSp || this.isHandleStoreChanges" class="l-tab-menu01__list-item l-tab-menu01__list-item--menu">
    <div class="l-tab-menu01__menu l-tab-menu01__menu--tb-pc-2col" role="tablist">
      <!-- Alipay (PC版)-->
      <button
        *ngIf="paymentMethod.get('AP')"
        aswThrottleClick
        (throttleClick$)="handleStore('AP')"
        [ngClass]="{ 'is-current': this.selectedPaymentMethod === 'AP' }"
        class="l-tab-menu01__menu-item"
        type="button"
        id="payment-input-aria-control-alipay1"
        role="tabpanel"
        aria-labelledby="tab-alipay"
        [attr.aria-selected]="this.selectedPaymentMethod === 'AP' ? 'true' : 'false'"
        [attr.tabindex]="this.selectedPaymentMethod === 'AP' ? '-1' : '0'"
      >
        <span class="l-tab-menu01__menu-title">
          <span class="l-tab-menu01__menu-title-icon">
            <img src="assets/images/logo_alipay.png" width="88" height="33" alt="{{ 'alt.alipay' | staticMsg }}" />
          </span>
        </span>
        <span class="l-tab-menu01__menu-mark"></span>
      </button>
      <!-- 銀聯 (PC版)-->
      <button
        *ngIf="paymentMethod.get('CU')"
        aswThrottleClick
        (throttleClick$)="handleStore('CU')"
        [ngClass]="{ 'is-current': this.selectedPaymentMethod === 'CU' }"
        class="l-tab-menu01__menu-item"
        type="button"
        id="payment-input-panel-cu1"
        role="tabpanel"
        aria-labelledby="aria-control-cu1"
        [attr.aria-selected]="this.selectedPaymentMethod === 'CU' ? 'true' : 'false'"
        [attr.tabindex]="this.selectedPaymentMethod === 'CU' ? '-1' : '0'"
      >
        <span class="l-tab-menu01__menu-title">
          <span class="l-tab-menu01__menu-title-icon">
            <img src="assets/images/logo_chinaUnionPay.png" width="88" height="33" alt="{{ 'alt.cup' | staticMsg }}" />
          </span>
        </span>
        <span class="l-tab-menu01__menu-mark"></span>
      </button>

      <!-- クレジットカード (PC版)-->
      <button
        *ngIf="paymentMethod.get('CD')"
        aswThrottleClick
        (throttleClick$)="handleStore('CD')"
        [ngClass]="{
          'is-current':
            this.selectedPaymentMethod === 'CD' || (this.isCreditCardCombination && this.selectedPaymentMethod === 'SC')
        }"
        class="l-tab-menu01__menu-item"
        type="button"
        id="payment-input-payment-methods-button-2"
        role="tab"
        aria-controls="panel-cc"
        [attr.aria-selected]="
          selectedPaymentMethod === 'CD' || (isCreditCardCombination && selectedPaymentMethod === 'SC')
            ? 'true'
            : 'false'
        "
        [attr.tabindex]="
          this.selectedPaymentMethod === 'CD' || (this.isCreditCardCombination && this.selectedPaymentMethod === 'SC')
            ? '-1'
            : '0'
        "
      >
        <span class="l-tab-menu01__menu-title">
          <span class="l-tab-menu01__menu-title-icon">
            <img
              src="assets/images/icon_credit_card_24.svg"
              width="24"
              height="24"
              alt="{{ 'alt.creditCard' | staticMsg }}"
            />
          </span>
          <span
            class="l-tab-menu01__menu-title-label l-tab-menu01__menu-title-label--em"
            [innerHTML]="
              this.posCountryCode === 'JP'
                ? ('label.creditCard' | staticMsg)
                : ('heading.creditCardOrDebitCardForTitle' | staticMsg)
            "
          ></span>
        </span>
        <span class="l-tab-menu01__menu-mark"></span>
      </button>
      <!-- ANA SKYコイン (PC版)-->
      <button
        *ngIf="paymentMethod.get('SC')"
        aswThrottleClick
        (throttleClick$)="handleStore('SC')"
        [ngClass]="{
          'is-current':
            this.selectedPaymentMethod === 'SC' || (this.isAnaSkyCoinCombination && this.selectedPaymentMethod === 'CD')
        }"
        class="l-tab-menu01__menu-item"
        type="button"
        id="payment-input-tab-sky-coins"
        role="tab"
        aria-controls="panel-sky-coins"
        [attr.aria-selected]="
          this.selectedPaymentMethod === 'SC' || (this.isAnaSkyCoinCombination && this.selectedPaymentMethod === 'CD')
            ? 'true'
            : 'false'
        "
        [attr.tabindex]="
          this.selectedPaymentMethod === 'SC' || (this.isAnaSkyCoinCombination && this.selectedPaymentMethod === 'CD')
            ? '-1'
            : '0'
        "
      >
        <span class="l-tab-menu01__menu-title">
          <span class="l-tab-menu01__menu-title-icon">
            <img
              src="assets/images/icon_ana_sky_coins_24.svg"
              width="24"
              height="24"
              alt="{{ 'alt.anaSKYCoins' | staticMsg }}"
            />
          </span>
          <span
            class="l-tab-menu01__menu-title-label l-tab-menu01__menu-title-label--em"
            [innerHTML]="'alt.anaSKYCoins' | staticMsg"
          ></span>
        </span>
        <span class="l-tab-menu01__menu-mark"></span>
      </button>
      <!-- Paypal (PC版)-->
      <button
        *ngIf="paymentMethod.get('PP')"
        aswThrottleClick
        (throttleClick$)="handleStore('PP')"
        [ngClass]="{ 'is-current': this.selectedPaymentMethod === 'PP' }"
        class="l-tab-menu01__menu-item"
        type="button"
        id="payment-input-tab-paypal"
        role="tab"
        aria-controls="panel-paypal"
        [attr.aria-selected]="this.selectedPaymentMethod === 'PP' ? 'true' : 'false'"
        [attr.tabindex]="this.selectedPaymentMethod === 'PP' ? '-1' : '0'"
      >
        <span class="l-tab-menu01__menu-title">
          <span class="l-tab-menu01__menu-title-icon">
            <img src="assets/images/logo_paypal.svg" width="88" height="33" alt="{{ 'alt.paypal' | staticMsg }}" />
          </span>
        </span>
        <span class="l-tab-menu01__menu-mark"></span>
      </button>
      <!-- コンビニエンスストア (PC版)-->
      <button
        *ngIf="paymentMethod.get('CV')"
        aswThrottleClick
        (throttleClick$)="handleStore('CV')"
        [ngClass]="{ 'is-current': this.selectedPaymentMethod === 'CV' }"
        class="l-tab-menu01__menu-item"
        type="button"
        id="payment-input-tab-cvs"
        role="tab"
        aria-controls="panel-cvs"
        [attr.aria-selected]="this.selectedPaymentMethod === 'CV' ? 'true' : 'false'"
        [attr.tabindex]="this.selectedPaymentMethod === 'CV' ? '-1' : '0'"
      >
        <span class="l-tab-menu01__menu-title">
          <span class="l-tab-menu01__menu-title-icon">
            <img
              src="assets/images/icon_convenience_store_24.svg"
              width="24"
              height="24"
              alt="{{ 'alt.convenienceStore' | staticMsg }}"
            />
          </span>
          <span
            class="l-tab-menu01__menu-title-label l-tab-menu01__menu-title-label--em"
            [innerHTML]="'alt.convenienceStore' | staticMsg"
          ></span>
        </span>
        <span class="l-tab-menu01__menu-mark"></span>
      </button>
      <!-- 銀行振込 (PC版)-->
      <button
        *ngIf="paymentMethod.get('IB')"
        aswThrottleClick
        (throttleClick$)="handleStore('IB')"
        [ngClass]="{ 'is-current': this.selectedPaymentMethod === 'IB' }"
        class="l-tab-menu01__menu-item"
        type="button"
        id="payment-input-tab-net-tfr"
        role="tab"
        aria-controls="panel-net-tfr"
        [attr.aria-selected]="this.selectedPaymentMethod === 'IB' ? 'true' : 'false'"
        [attr.tabindex]="this.selectedPaymentMethod === 'IB' ? '-1' : '0'"
      >
        <span class="l-tab-menu01__menu-title">
          <span class="l-tab-menu01__menu-title-icon">
            <img
              src="assets/images/icon_internet_transfer_24.svg"
              width="24"
              height="24"
              alt="{{ 'heading.internetBanking' | staticMsg }}"
            />
          </span>
          <span
            class="l-tab-menu01__menu-title-label l-tab-menu01__menu-title-label--em"
            [innerHTML]="'heading.internetBanking' | staticMsg"
          ></span>
        </span>
        <span class="l-tab-menu01__menu-mark"></span>
      </button>
      <!-- PE (PC版)-->
      <button
        *ngIf="paymentMethod.get('PE')"
        (click)="handleStore('PE')"
        [ngClass]="{ 'is-current': this.selectedPaymentMethod === 'PE' }"
        class="l-tab-menu01__menu-item"
        type="button"
        id="payment-input-tab-ep-tfr"
        role="tab"
        aria-controls="panel-net-tfr"
        [attr.aria-selected]="this.selectedPaymentMethod === 'PE' ? 'true' : 'false'"
        [attr.tabindex]="this.selectedPaymentMethod === 'PE' ? '-1' : '0'"
      >
        <span class="l-tab-menu01__menu-title">
          <span class="l-tab-menu01__menu-title-icon">
            <img src="assets/images/logo_payeasy.svg" width="54" height="40" alt="{{ 'label.payeasy' | staticMsg }}" />
          </span>
        </span>
        <span class="l-tab-menu01__menu-mark"></span>
      </button>
    </div>
  </li>
  <!-- ▲▲▲ タブ機能のPC版 ここまで ▲▲▲ -->
  <li *ngIf="!isSp || this.isHandleStoreChanges" class="l-tab-menu01__list-item l-tab-menu01__list-item--info">
    <ul class="c-information-list01 c-information-list01--large">
      <li class="c-information-list01__item">
        <span class="c-information-list01__text" [innerHTML]="'label.preferredPayment' | staticMsg">
          <a
            id="payment-input-external_primary0"
            class="c-information-list01__link l-tab-menu01__text-link"
            href="#"
            target="_blank"
          >
            <img
              class="c-text-link-external c-text-link-external--large"
              src="assets/images/icon_external_primary_20.svg"
              width="20"
              height="20"
              [alt]="'alt.openLinkInNewTab' | staticMsg"
            />
          </a>
        </span>
      </li>
    </ul>
  </li>
  <li *ngIf="!isSp || this.isHandleStoreChanges" class="l-tab-menu01__list-item l-tab-menu01__list-item--appt">
    <div class="l-tab-menu01__menu" role="tablist">
      <button
        class="l-tab-menu01__menu-item"
        type="button"
        *ngIf="paymentMethod.get('RE')"
        id="payment-input-tab-appt"
        role="tab"
        aria-controls="panel-appt"
        [ngClass]="{ 'is-current': this.selectedPaymentMethod === 'RE' }"
        [attr.aria-selected]="isReservationOnly"
        [attr.tabindex]="isReservationOnly ? '-1' : '0'"
        (click)="handleStore('RE')"
      >
        <span class="l-tab-menu01__menu-title">
          <span class="l-tab-menu01__menu-title-label" [innerHTML]="'label.reserveOnly' | staticMsg"> </span>
        </span>
        <span class="l-tab-menu01__menu-mark"></span>
      </button>
    </div>
  </li>
  <li
    *ngIf="isCreditCardOrConvinienceStoreSelected()"
    class="l-tab-menu01__list-item l-tab-menu01__list-item--mt16 l-tab-menu01__list-item--check"
  >
    <div class="c-form-element-checkbox">
      <div class="c-form-element-checkbox__wrap">
        <label for="payment-input-payment-methods-checkbox1-1" class="c-form-element-checkbox__label">
          <asw-checkbox
            [formControl]="saveAsUsualCheckboxControl"
            (change$)="update()"
            [label]="'label.saveAsUsualPaymentMthod' | staticMsg"
          >
          </asw-checkbox>
        </label>
      </div>
    </div>
  </li>
</ul>
